import { api } from "@/lib/api";
import { createContext, useContext } from "react";
import useSWR from "swr";

const fetcher = (url) => api.get(url).then((r) => r.data);

export function useSystem() {
  return useSWR("/system/status", fetcher, { refreshInterval: 5000 });
}

export function useSites() {
  return useSWR("/sites", fetcher, { refreshInterval: 3000 });
}

export function useServers() {
  return useSWR("/servers", fetcher, { refreshInterval: 5000 });
}

export function useServer(id) {
  return useSWR(id ? `/servers/${id}` : null, fetcher, { refreshInterval: 5000 });
}

export function useBootstrapStatus(id) {
  return useSWR(id ? `/servers/${id}/bootstrap` : null, fetcher, { refreshInterval: 1500 });
}

export function useSite(id) {
  return useSWR(id ? `/sites/${id}` : null, fetcher, { refreshInterval: 3000 });
}

export function useSiteConfig(id) {
  return useSWR(id ? `/sites/${id}/config` : null, fetcher);
}

export function useSiteHistory(id) {
  return useSWR(id ? `/sites/${id}/history` : null, fetcher, { refreshInterval: 5000 });
}

export function useSiteSourceStatus(id) {
  return useSWR(id ? `/sites/${id}/source-status` : null, fetcher, { refreshInterval: 10000 });
}

export function useActivity() {
  return useSWR("/activity?limit=30", fetcher, { refreshInterval: 5000 });
}

export function useSiteLogs(id) {
  return useSWR(id ? `/sites/${id}/logs` : null, fetcher, { refreshInterval: 2000 });
}

export function useSettings() {
  return useSWR("/settings", fetcher);
}

export function useInstallerInfo() {
  return useSWR("/installer/info", fetcher);
}

export const stackLabel = (t) => ({
  static: "Static",
  react_spa: "React SPA",
  fullstack_farm: "Full-stack (FastAPI + React + Mongo)",
  custom_docker: "Custom Docker",
  unknown: "Unknown",
}[t] || t);

export const StackIcon = ({ type, className = "h-4 w-4" }) => {
  // returns null; component filled in Sites list per icon rules
  return null;
};
